// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner-container[data-v-4c68f4e0]{background-image:linear-gradient(96deg,#a197b5 6%,#daceea 84%);min-height:16.5rem}@media(min-width:992px){.banner-container[data-v-4c68f4e0]{min-height:22.5rem}}.banner-image-container[data-v-4c68f4e0]{width:35%}.banner-spacer[data-v-4c68f4e0]{flex-grow:1}@media(max-width:767px){.banner-spacer[data-v-4c68f4e0]{height:3rem}}.close-button[data-v-4c68f4e0]{position:absolute;right:20px;top:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
